import React, { useState } from 'react';
import Modal from './Modal';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import BaseText from '../ui/typography/BaseText';
import {
  ACCOUNTING_PRICE,
  FONT_SIZE,
  API_ERROR_CODES,
  API_CODE,
  HUBSPOT_INTEGRATION,
  EMAIL_JS
} from '../../constants/enum';
import InputSM from '../ui/Input/InputSM';
import PrimaryButton from '../ui/buttons/PrimaryButton';
import SelectInput from '../ui/Input/SelectInput';
import H3HeaderText from '../ui/typography/H3HeaderText';
import { PAGES_ENDPOINTS } from '../../constants/pages-endpoints';
import { navigate } from 'gatsby';
import { send } from '@emailjs/browser';

export default function AccountingModal({ children, price }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    reset();
    setIsSubmitted(false);
    setIsModalOpen(false);
  };
  const PACKAGE_OPTION = [
    { name: 'Light - $95USD/month', value: 'Light - $95USD/month' },
    { name: 'Small Business - $150USD/month', value: 'Small Business - $150USD/month' },
    { name: 'Growth - $215USD/month', value: 'Growth - $215USD/month' }
  ];
  const defaultPackageSelector = () => {
    if (price === `$${ACCOUNTING_PRICE?.LIGHT}`) {
      return PACKAGE_OPTION[0]?.value;
    }
    if (price === `$${ACCOUNTING_PRICE?.SMALL_BUSINESS}`) {
      return PACKAGE_OPTION[1]?.value;
    }
    if (price === `$${ACCOUNTING_PRICE?.GROWTH}`) {
      return PACKAGE_OPTION[2]?.value;
    }
  };
  const schema = yup.object({
    fullName: yup.string().required('Full Name'),
    companyName: yup.string().required('Company Name'),
    email: yup.string().email().required('Email'),
    package: yup.string().required('package')
  });
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      package: defaultPackageSelector()
    }
  });
  function templateParamsForMail(data) {
    let templateParams = {
      email: data?.email,
      package: data?.package,
      shfirstname: data?.fullName,
      shlastname: 'from accounting',
      company1: data?.companyName
    };
    return templateParams;
  }
  const sendingEmailJs = async (data) => {
    await send(
      EMAIL_JS.EMAIL_JS_SERVICE_ID,
      EMAIL_JS?.GET_STARTED_TEMPLATE_ID,
      templateParamsForMail(data),
      EMAIL_JS.PUBLIC_KEY
    ).then(
      function (response) {
        console.log(response);
      },
      function (error) {
        console?.log(error);
      }
    );
  };
  const onSubmit = async (data) => {
    setIsLoading(true);
    await sendingEmailJs(data, EMAIL_JS?.GET_STARTED_TEMPLATE_ID);
    var payload = {
      fields: [
        {
          name: 'full_name',
          value: data?.fullName ? data?.fullName : ''
        },
        {
          name: 'company',
          value: data?.companyName ? data?.companyName : ''
        },
        {
          name: 'email',
          value: data?.email ? data?.email : ''
        },
        {
          name: 'package',
          value: data?.package ? data?.package : ''
        },
        {
          name: 'submission_type',
          value: 'accounting'
        }
      ],
      context: {
        pageUri: 'https://air-corporate.com/getstarted/',
        pageName: 'getstarted'
      }
    };
    var final_data = JSON.stringify(payload);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', HUBSPOT_INTEGRATION?.ACCOUNTING);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(final_data);
    xhr.onreadystatechange = async function () {
      if (xhr.readyState == 4 && xhr.status == API_CODE.STATUS_200) {
        navigate(PAGES_ENDPOINTS.THANK_YOU);
      } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_400) {
        alert(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_403) {
        alert(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_404) {
        alert(xhr.responseText);
      }
      setIsLoading(false);
    };
  };

  return (
    <div>
      <div onClick={handleOpenModal}>{children}</div>
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        {isSubmitted ? (
          <div className="pt-12 pb-32">
            <H3HeaderText title={'Thanks for Submitting the form'} />
          </div>
        ) : (
          <div>
            <BaseText
              className="md:whitespace-pre-line"
              fontSize={FONT_SIZE?.PX_20}
              title={`Have any questions about your new \ncompany in Hong Kong?`}
            />
            <BaseText textColor="text-gray-200" title="Fill the form and we will reach out soon!" />
            <InputSM
              label="Your Full Name"
              inputProps={{ ...register(`fullName`) }}
              error={errors?.fullName?.message}
            />
            <InputSM
              label="Your Company Name"
              inputProps={{ ...register(`companyName`) }}
              error={errors?.companyName?.message}
            />
            <InputSM label="Your email" inputProps={{ ...register(`email`) }} error={errors?.email?.message} />
            <SelectInput
              label={'Package'}
              size="sm"
              inputProps={{ ...register('package') }}
              error={errors.package?.message}
              options={PACKAGE_OPTION}
            />
            <PrimaryButton
              type="submit"
              isLoading={isLoading}
              onClick={handleSubmit(onSubmit)}
              padding="16px"
              fontSize={FONT_SIZE?.PX_16}
              className="w-full mt-6 mb-4 hover:bg-gray-700 hover:text-white"
              caption="Send"
            />
          </div>
        )}
      </Modal>
    </div>
  );
}

AccountingModal.defaultProps = {
  iconOnly: true
};
